import React from "react"

function WeeklyProjections(){
    return <React.Fragment>
        <iframe title="WeeklyProjections" width="1400" height="800" src="https://app.powerbi.com/reportEmbed?reportId=0d728f13-a23c-4a3f-b277-ee4f8787038a&autoAuth=true&ctid=49423d5d-8d49-4128-b53d-59537808f6ac&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtYi1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D" ></iframe>
    </React.Fragment>
}

export{WeeklyProjections}